import { render, staticRenderFns } from "./PopupInvoicePreviewDuplicates.vue?vue&type=template&id=ba1e203c&scoped=true&"
import script from "./PopupInvoicePreviewDuplicates.vue?vue&type=script&lang=js&"
export * from "./PopupInvoicePreviewDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./PopupInvoicePreviewDuplicates.vue?vue&type=style&index=0&id=ba1e203c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1e203c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDialog,VRow})
